import React, { useState } from 'react';
import '../../styles/modal/CoreModal.css';
import '../../styles/boat/BoatLeadModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import BoatLeadForm from '../../forms/boats/BoatLeadForm';
import { validateBoatLeadForm } from '../../validations/BoatLeadValidation';
import BoatLeadService from '../../services/BoatLeadService';
import BoatLeadSuccessModal from './BoatLeadSuccessModal';
import ReactDOM from 'react-dom';

const BoatLeadModal = ({ onClose, boat }) => {
  const [formData, setFormData] = useState({
    boat_id: boat?.id || '',
    fullName: '',
    email: '',
    phone: '',
    date: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetAndClose = () => {
    setFormData({
      boat_id: boat?.id || '',
      fullName: '',
      email: '',
      phone: '',
      date: '',
      message: '',
    });
    setShowSuccessModal(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateBoatLeadForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const newLead = {
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        date: formData.date || null,
        message: formData.message || null,
        boat: formData.boat_id,
      };

      await BoatLeadService.createLead(newLead);
      setShowSuccessModal(true);
    } catch (error) {
      setErrors({ submit: 'Error sending the form. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const stopPropagation = (e) => e.stopPropagation();

  const coreApp = document.getElementById('core-app');
  return ReactDOM.createPortal(
    <div className="core__modal" onClick={handleResetAndClose}>
      <div className="core__modal-content" onClick={stopPropagation}>
        <div className="core__modal-header">
          <h2>Booking Inquiry</h2>
          <button className="core__modal-close" onClick={handleResetAndClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        
        <div className="core__modal-body">
          <p className="core__modal-intro-text">
            Please note this is only a request. We will contact you to finalize your booking.
          </p>
          <BoatLeadForm formData={formData} errors={errors} handleChange={handleChange} />
          {errors.submit && <span className="error-message">{errors.submit}</span>}
          
          <div className="privacy-assurance">
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>We won't share your data.</span>
          </div>
          
          <div className="core__modal-buttons">
            <button className="button" onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Inquiry'}
            </button>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <BoatLeadSuccessModal 
          onClose={handleResetAndClose}
        />
      )}
    </div>,
    coreApp
  );
};

export default BoatLeadModal; 